import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { Spinner } from '@/components/ui';

/**
 * Admin-Gate: wie ProtectedRoute, zusätzlich Rollencheck (role==='admin').
 * Nicht eingeloggt → /login; eingeloggt aber kein Admin → zurück zu /matchdays.
 */
export function AdminRoute() {
  const { user, initializing } = useAuth();
  const location = useLocation();

  if (initializing) return <Spinner label="Sitzung wird geprüft…" />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (user.role !== 'admin') return <Navigate to="/matchdays" replace />;
  return <Outlet />;
}
